import { captureReactException } from '@sentry/react';
import { Component } from 'react';

/**
 * Error Boundary global da aplicação.
 *
 * Captura qualquer erro de renderização não tratado e mostra uma tela de
 * fallback amigável em vez de deixar a tela em branco.
 */
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Envia para o Sentry junto com o componentStack, que e o que diz QUAL
        // componente quebrou. Sem DSN configurado esta chamada e no-op.
        captureReactException(error, errorInfo);

        // eslint-disable-next-line no-console
        console.error('Erro não tratado capturado pelo ErrorBoundary:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f4f4f5',
                    padding: '1.5rem',
                }}>
                    <div style={{
                        background: '#fff',
                        borderRadius: '0.75rem',
                        padding: '2rem',
                        maxWidth: '420px',
                        textAlign: 'center',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    }}>
                        <h1 style={{ marginBottom: '0.5rem' }}>Ops, algo deu errado</h1>
                        <p style={{ marginBottom: '1.5rem', color: '#555' }}>
                            Ocorreu um erro inesperado ao carregar esta página. Recarregue para continuar.
                        </p>
                        <button
                            onClick={this.handleReload}
                            style={{
                                padding: '0.6rem 1.4rem',
                                borderRadius: '0.5rem',
                                border: 'none',
                                background: '#16a34a',
                                color: '#fff',
                                cursor: 'pointer',
                                fontWeight: 600,
                            }}
                        >
                            Recarregar página
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
